export default {
    'FETCH_SHIPMENTS' (state, data) {
        state.shipments = data;
  }
}